import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './home.css';
import Button from '../components/button';
import Settings from '../components/settings';
import coin from '../assets/coin.gif';
import coin_sound from '../assets/coin.mp3';
import homegirl from '../assets/homegirl.gif';
import money_sound from '../assets/money.mp3';
import money from '../assets/money.png';
import settings from '../assets/settings.png';
import { play_sound, stop_sound } from '../audio_settings';

const BONUS_REWARD = 100;
const MONEY_STEP = 5;

const Home = (props) => {
  const navigate = useNavigate();
  const coinAudioRef = useRef(null);
  const moneyAudioRef = useRef(null);
  const moneyIntervalRef = useRef(null);
  const claimingBonusRef = useRef(false);
  const [gainingMoney, setGainingMoney] = useState(false);

  useEffect(() => {
    if (props.showBonus) {
      play_sound(coinAudioRef.current);
    } else {
      stop_sound(coinAudioRef.current);
    }
  }, [props.showBonus]);

  useEffect(() => {
    const coinAudio = coinAudioRef.current;
    const moneyAudio = moneyAudioRef.current;

    return () => {
      window.clearInterval(moneyIntervalRef.current);
      stop_sound(coinAudio);
      stop_sound(moneyAudio);
    };
  }, []);

  useEffect(() => {
    const stopDisabledSounds = (event) => {
      if (event.detail.name === 'sound' && !event.detail.value) {
        stop_sound(coinAudioRef.current);
        stop_sound(moneyAudioRef.current);
      }
    };

    window.addEventListener('audio_setting_change', stopDisabledSounds);
    return () => window.removeEventListener('audio_setting_change', stopDisabledSounds);
  }, []);

  const stopMoneyGain = () => {
    window.clearInterval(moneyIntervalRef.current);
    setGainingMoney(false);
  };

  const claimBonus = () => {
    if (claimingBonusRef.current) return;

    claimingBonusRef.current = true;
    coinAudioRef.current.pause();
    localStorage.setItem('bonus_claimed', 'true');
    props.setShowBonus(false);
    setGainingMoney(true);
    play_sound(moneyAudioRef.current);

    let awarded = 0;
    moneyIntervalRef.current = window.setInterval(() => {
      awarded += MONEY_STEP;
      props.setMoneyCount((count) => count + MONEY_STEP);

      if (awarded >= BONUS_REWARD) {
        stopMoneyGain();
      }
    }, 80);
  };

  return (
    <div className="home">
      <audio ref={coinAudioRef} src={coin_sound} />
      <audio ref={moneyAudioRef} src={money_sound} />

      <div className="home_top">
        <Button className="home_settings" onclick={() => props.setShowSettings(true)}>
          <img src={settings} alt="" />
        </Button>

        <div className={`home_money ${gainingMoney ? 'home_money_active' : ''}`}>
          <img src={money} alt="" />
          <span className="home_money_count">{props.moneyCount}</span>
        </div>
      </div>

      <img className="home_girl" src={homegirl} alt="" />

      <Button className="home_button" onclick={() => navigate('/levels')}>
        Play
      </Button>

      {props.showSettings && (
        <Settings onclose={() => props.setShowSettings(false)} />
      )}

      {props.showBonus && (
        <div className="bonus_overlay">
          <div className="bonus_panel">
            <img className="bonus_coin" src={coin} alt="" />
            <Button className="bonus_claim_button" onclick={claimBonus}>
              Claim
            </Button>
          </div>
        </div>
      )}
    </div>
  );
}

export default Home;
